<!-- Main container -->
<div class="layout-col full">
  <elder-table class="flex" matSort [data]="data" [idField]="'id'" (itemClick)="openDetail($event)">
    <!-- icon Column -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 30px"></th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>widgets</mat-icon>
      </td>
    </ng-container>

    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.id' | translate }}
      </th>
      <td mat-cell *matCellDef="let batch">{{ batch.number }}</td>
    </ng-container>

    <!-- state Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'context.state' | translate }}
      </th>
      <td mat-cell *matCellDef="let batch">{{ 'WorkBatchState.' + batch.state | translate }}</td>
    </ng-container>

    <!-- numberOfItems Column -->
    <ng-container matColumnDef="numberOfItems">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'context.items' | translate }}
      </th>
      <td mat-cell *matCellDef="let batch">{{ batch.numberOfItems }}</td>
    </ng-container>

    <!-- piecesCount Column -->
    <ng-container matColumnDef="piecesCount">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'context.pieces' | translate }}
      </th>
      <td mat-cell *matCellDef="let batch">
        {{ batch.quantities ? batch.quantities['STK']?.value : '-' }}
      </td>
    </ng-container>

    <!-- weight Column -->
    <ng-container matColumnDef="weight">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'context.weight' | translate }}
      </th>
      <td mat-cell *matCellDef="let batch">{{ batch.weight | elderQuantity }}</td>
    </ng-container>

    <!-- workBatchLine Column -->
    <ng-container matColumnDef="workBatchLine">
      <th mat-header-cell *matHeaderCellDef class="cell-10 align-right">
        {{ 'context.status' | translate }}
      </th>
      <td mat-cell *matCellDef="let batch" class="align-right">
        <app-work-batch-line style="width: 100%" [batch]="batch"></app-work-batch-line>
      </td>
    </ng-container>
  </elder-table>
</div>
